(function($) {
    $(window).load(function() {
        /* Sliders management */
        var slider_opt = {
            items: 1,
            loop: true,
            dots: false,
            nav: true,
            navElement: 'a',
            // navText: ['<i class="icon icon-left-arrow"></i>', '<i class="icon icon-right-arrow"></i>'],
            navClass: ['owl-prev', 'owl-next'],
            autoplay: false,
            mouseDrag: false,
            touchDrag: true,
            // autoplayHoverPause: true,
        };

        var sliders = $('.owl-carousel').filter(function () {
            return $(this).find('.slide').length > 1;
        });

        if ( sliders.length > 0 ) {
            sliders.each(function () {
                var slider = $(this);
                if (slider.is('.slider--home')) {
                    slider.owlCarousel($.extend({}, slider_opt, {
                        autoplay: true,
                        autoplayTimeout: 6000,

                    }));
                } else if (slider.is('.slider--related')) {
                    var items = $('.slide', slider).length > 2 ? 3 : 2;
                    slider.owlCarousel($.extend({}, slider_opt, {
                        items: items,
                        stagePadding: 0,
                        margin: 20,
                        smartSpeed: 500,
                        nav: true,
                        autoplay: true,
                        autoplayHoverPause: true,
                        responsiveClass: true,
                        responsive:{
                            0:{
                                loop: items > 1 ? true : false,
                                items: 1,
                            },
                            600:{
                                loop: items > 2 ? true : false,
                                items: items > 2 ? 2 : 1,
                            },
                            1000:{
                                loop: items > 3 ? true : false,
                                items: items,
                            }
                        }
                    }));
                } else if (slider.is('.slider--images')) {
                    slider.owlCarousel($.extend({}, slider_opt, {
                        //autoplay: true,
                        //autoplayTimeout: 6000,
                    }));
                } else if (slider.is('.slider--products')) {
                    slider.owlCarousel($.extend({}, slider_opt, {
                        autoplay: true,
                        autoplayTimeout: 6000,
                        autoplayHoverPause:false,
                    }));
                } else {
                    slider.owlCarousel(slider_opt);
                }
            });
        }

        /* Manage for Mailchimp 4 WordPress */        
        var $mc4wp_response = $('.mc4wp-response', '.newsletter__modal');
        var $mc4wp_notice = $('.mc4wp-notice', '.newsletter__modal');
        var $mc4wp_error = $('.mc4wp-error', '.newsletter__modal');
        var $mc4wp_success = $('.mc4wp-success', '.newsletter__modal');
        var $mc4wp_fields = $('.mc4wp-form-fields', '.newsletter__modal');


        if ( $mc4wp_success.length > 0 ) {
            $mc4wp_fields.hide();
        }

        if ( 0 < $mc4wp_response.children().length ) {
            $('#newsletter-modal').modal('toggle');
        }

        $('[data-toggle="lightbox"]').each(
            function(index, anchor) {
                $(anchor).click(
                    function(event) {
                        event.preventDefault();
                        $(this).ekkoLightbox();
                    }
                );
            }
        );
    });
})(jQuery);

(function($) {

    /* Srcset implementation for background-image */
    function imageCurrentSrc(el) {
        var img = $(el);
        return typeof img.prop('currentSrc') !== 'undefined' ? img.prop('currentSrc') : img.attr('src');
    }

    function imageToBackgroundImage(e) {
        var img = e instanceof Event ? e.target : e;
        var container = $(img).parents('.js-bg');
        if ($(img).is('.js-bg__img') || container.find('img').length == 1) {
            container.css('background-image', 'url(' + imageCurrentSrc(img) + ')');
            $(img).hide();
        }
    }

    /* Srcset implementation for background-image */
    function switchSrc(el, parent) {
        var src = imageCurrentSrc(el);
        $(el).parents('.' + parent).css('background-image', 'url(' + src + ')').addClass(parent + '--loaded').end().hide();
    }

    function checkBackgroundImages(params) {
        var parent_selector = 'js-bg';
        $('.' + parent_selector).each(function () {
            var imgs = $(this).find('.js-bg__img').length ? $(this).find('.js-bg__img') : $(this).find('img');
            imgs.on('load', function () {
                switchSrc(this, parent_selector);
            }).each(function () {
                if (this.complete) {
                    switchSrc(this, parent_selector);
                }
            });
        });
    }

    $(document).ready(function() {
        $('a.active', 'section.month__tabs').each(function(index, element) {
            var month = $(element).data('month');
            $('[data-target="#months-mobile"]').text( $(element).text() );

            $('.month-' + month, '.month__events' ).show(100, function() {
                $('.month__events').fadeIn();
            });
        });
        $('a', '.month__tabs').each(function(index, element) {
            $(element).click(function(event) {
                var id = $(element).attr('href').slice(1);
                var i  = 0;
                var hiding = $.Deferred();
                event.preventDefault();

                hiding.then(function( id ) {
                    var showing = $.Deferred();
                    var tobe_showed = $('.month-' + id, '.month__events' );
                    
                    showing.then(function() {
                        $('.month__events').fadeIn(400, function() {
                            $('.month__events').css('height', '');
                        });
                    });
                    
                    for ( var i = 0; i < tobe_showed.length; i++){
                        $(tobe_showed[i]).fadeIn();
                    }
                    showing.resolve();
                });

                if ( $(this).is('.active') ) {
                    return event;
                }

                $('a', '.month__tabs').each(function(index, element) {$(element).removeClass('active');});
                $('[data-month="' + $(this).data('month') + '"]').addClass('active');

                $('.month__events').fadeOut(400, function() {
                    var articles = $('article', '.month__events');
                    $('#months-mobile').collapse('hide');
                    $('[data-target="#months-mobile"]').text( $(element).text() );
                    for ( i = 0; i < articles.length; i++ ) {
                        $(articles[i]).hide();
                    }
                    hiding.resolve( id );
                });
                return event;
            });
        });
        $('.gallery').each(
            function(index, gallery) {
                var gallery_id = $(gallery).attr('id');
                $('.gallery-item', gallery).each(
                    function(index, item) {
                        var caption = $('.wp-caption-text', item).text();
                        $('a', item).attr('data-footer', caption);
                    }
                );

                $('a', gallery).each(
                    function(index, anchor) {
                        $(anchor).attr('data-toggle', 'lightbox');
                        $(anchor).attr('data-gallery', gallery_id);
                    }
                );
            }
        );

        $('.wp-caption').each(
            function(index, figure) {
                var caption_id = $(figure).attr('aria-describedby');
                var caption = $('#' + caption_id).text();

                $('a', figure).each(
                    function(index, anchor) {
                        $(anchor).attr('data-footer', caption);
                        $(anchor).attr('data-toggle', 'lightbox');
                    }
                );
            }
        );
        /* activate lazy loading */
        checkBackgroundImages();
    });
})(jQuery);

(function($) {
    $(document).ready(
        function() {
            var $exhibition = $("#exhibition");
            // var $exhibition_index = $("#exhibition-index");
            // var $exhibition_button = $('[data-target="#exhibition-container"]');
            // var $exhibition_dismiss = $('[data-dismiss="modal"]', '#exhibition-container');
            var ex_config = 
            {
                items: 1,
                center: true,
                nav: true,
                dots: true,
                dotsData: true,
                URLhashListener: true,
                // autoHeight: true,
                onInitialized: function(e) {
                    owl_dots_image_resize_handler();
                    owl_stage_resize_handler();
                },
                onResized: function(e) {
                    owl_dots_image_resize_handler();
                    owl_stage_resize_handler();
                },
                onChange: function(e) {
                    $('.exhibition__carousel--index-item').eq(e.item.index).removeClass('current');
                },
                onChanged: function(e) {
                    var pages = e.item.count;
                    var page = e.item.index + 1;
                    var $span_pages = $('<span>').text(pages);
                    var $span_page =  $('<span>').text(page);
                    $('.exhibition__carousel--pages', '.exhibition__carousel').empty();
                    $('.exhibition__carousel--pages', '.exhibition__carousel').append($span_page);
                    $('.exhibition__carousel--pages', '.exhibition__carousel').append($('<span>/</span>'));
                    $('.exhibition__carousel--pages', '.exhibition__carousel').append($span_pages);
                    $('.exhibition__carousel--index-item').eq(page - 1).addClass('current');
                    owl_dots_image_resize_handler();
                    owl_stage_resize_handler();
                },
            }

            $('[data-toggle="lightbox-exhibition"]').each(
                function(index, anchor) {
                    $(anchor).click(
                        function(event) {
                            event.preventDefault();
                            var index = $(this).data('index');
                            $instance = $.fancybox.open(
                                $('[data-fancybox]'),
                                {
                                    buttons: [
                                        'zoom',
                                        'slideshow',
                                        'close',
                                    ],
                                    animationEffect: "fade",
                                }
                            );
                            if ( index > 0 ) {
                                $instance.jumpTo(index, 0);
                            }
                            return event;
                        }
                    );
                }
            );

            $('#exhibition-container').on(
                'shown.bs.modal',
                function(e) {
                    var $img_not_lazyloaded = jQuery('img:not(.lazyloaded)', '#exhibition');

                    if ( $img_not_lazyloaded.length > 0 && typeof( LazyLoad ) != 'undefined' ) {
                        ll = new LazyLoad(lazyLoadOptions, $img_not_lazyloaded);
                        ll.loadAll();
                    }

                    $exhibition.owlCarousel(ex_config);
                    $('#exhibition-container').fadeIn({
                        "complete": owl_stage_resize_handler()
                    });

                    return e;
                }
            );

            $('#exhibition-container').on(
                'hidden.bs.modal',
                function(e) {
                    $('#exhibition-container').fadeOut(
                        400,
                        function() {
                            $exhibition.trigger('destroy.owl.carousel');
                        }
                    );
                    return e;
                }
            );

            function owl_dots_image_resize_handler() {
                var width = Math.floor($('.owl-dots').width()/$('.owl-dot', '.owl-dots').length);
                var scale = 0.80
                var css_dot = null
                var css_dots = {"flex-flow":""};
                
                if ( $(window).width() > 991 ){
                    width = width*scale;
                } else {
                    css_dots = {"flex-flow":"wrap"};
                }
                width = width > 150 ? 150 : width;
                css_dot = {
                    "width": width+"px",
                    "height": "auto"
                };

                // $('.owl-dots').css(css_dots);
                $('.owl-dot img', '.owl-dots').each(
                    function(i,e) {
                        $(e).css(css_dot);
                    }
                );
            }

            function owl_stage_resize_handler(){
                var height = $('.owl-stage').height();
                var height_title = $('div', '.owl-item.active.center .exhibition-description').first().height();
                if ( $(window).width() < 992 ) {
                    // mobile remove all setting
                    $('.exhibition-text', '.owl-item .exhibition-description').css({
                        "height":"",
                        "overflow":""
                    });
                } else {
                    // mdesktop add setting
                    $('.exhibition-text', '.owl-item.active.center .exhibition-description').css(
                        {
                            "height": (height-height_title)+"px",
                            "overflow": "hidden scroll"
                        }
                    );
                }
            }
        }
    );
})(jQuery);

(function($){
    $(document).on(
        'ready',
        function(e) {

            function update_cart_totals() {
                var value;
                var total_items = 0;
                
                if ( window.sessionStorage ) {
                    for ( i in sessionStorage ) {
                        if ( i.search('wc_fragments_') > -1 ) {
                            value = JSON.parse( sessionStorage.getItem(i) );
                            total_items = value.total_items == undefined ? 0 : value.total_items;
                            break;
                        }
                    }
                }

                $('div', '[title="Carrello"]').remove();

                $('[title="Carrello"]').append($('<div class="cart-totals">').text('' + total_items));
            }

            $( document.body ).trigger( 'wc_fragment_refresh' );
            $( document.body ).trigger( 'wc_fragments_refreshed' );

            update_cart_totals();

            $( document.body ).on(
                'added_to_cart',
                function() {
                    $( document.body ).trigger( 'wc_fragment_refresh' );
                    $( document.body ).trigger( 'wc_fragments_refreshed' );
                }
            );

            $( document.body ).on(
                'removed_from_cart',
                function() {
                    $( document.body ).trigger( 'wc_fragment_refresh' );
                    $( document.body ).trigger( 'wc_fragments_refreshed' );
                }
            );

            $( document.body ).on(
                'wc_fragments_refreshed',
                update_cart_totals
            );

            // Dropdown 3° level
            $('li.dropdown-submenu > a.dropdown-item').on('click', function(e) {
                console.log('click')
                if (!$(this).next().hasClass('show')) {
                    $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
                }
                var $subMenu = $(this).next(".dropdown-menu");
                $subMenu.toggleClass('show');

                $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
                    $('.dropdown-submenu .show').removeClass("show");
                });

                return false;
            });

        }
    )
})(jQuery);
